"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseConversion = require("nicbase-conversion");

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

require("./tour-mileage.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TourMileage = function TourMileage(_ref) {
  var _mileageCalculations$, _mileageCalculations$2;

  var mileageCalculations = _ref.mileageCalculations,
      lengthUnit = _ref.lengthUnit,
      status = _ref.status;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-distance-container"
  }, (mileageCalculations === null || mileageCalculations === void 0 ? void 0 : (_mileageCalculations$ = mileageCalculations.recommended) === null || _mileageCalculations$ === void 0 ? void 0 : _mileageCalculations$.value) > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xl pb-1 font-bold"
  }, mileageCalculations.recommended.type === 'gps' && /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.approx"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
    value: mileageCalculations === null || mileageCalculations === void 0 ? void 0 : (_mileageCalculations$2 = mileageCalculations.recommended) === null || _mileageCalculations$2 === void 0 ? void 0 : _mileageCalculations$2.value,
    from: "km",
    to: lengthUnit,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "description"
  }, status === _constants.TOUR_STATUS.RUNNING ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.currentTourDistance",
    tagName: "span"
  }) : /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tourDistance",
    tagName: "span"
  })));
};

TourMileage.propTypes = {
  mileageCalculations: _propTypes["default"].shape({
    recommended: _propTypes["default"].shape({
      value: _propTypes["default"].number,
      type: _propTypes["default"].string
    }),
    available: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].number,
      type: _propTypes["default"].string
    }))
  }),
  lengthUnit: _propTypes["default"].string,
  status: _propTypes["default"].string
};
TourMileage.defaultProps = {
  mileageCalculations: {},
  lengthUnit: 'km',
  status: 'WAITING'
};
var _default = TourMileage;
exports["default"] = _default;